import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, switchMap, take, tap } from 'rxjs';
import { AuthService } from './services/auth/auth-service';
import { environment } from '../environments/environment';
import { LOCAL_STORAGE_KEYS } from './constants/storage-keys';

@Injectable()
export class StartedFilesInterceptor implements HttpInterceptor {
  private authService: AuthService | undefined;

  constructor(private readonly injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.authService) {
      // Lazy injection to avoid circular dependency with AuthService
      this.authService = this.injector.get(AuthService);
    }
    return this.authService.isLoggedIn$.pipe(
      take(1),
      switchMap((isLoggedIn) => {
        if (req.url.startsWith(environment.BASE_API_URL) && isLoggedIn) {
          const startedFiles = localStorage.getItem(
            LOCAL_STORAGE_KEYS.STARTED_FILES
          );
          if (startedFiles) {
            const urlWithStartedFiles =
              req.urlWithParams +
              (req.url.includes('?') ? '&' : '?') +
              `startedFiles=${encodeURIComponent(startedFiles)}`;
            const modifiedReq = req.clone({ url: urlWithStartedFiles });

            return next.handle(modifiedReq).pipe(
              tap((event) => {
                if (
                  event instanceof HttpResponse &&
                  event.status >= 200 &&
                  event.status < 300
                ) {
                  localStorage.removeItem(LOCAL_STORAGE_KEYS.STARTED_FILES);
                }
              })
            );
          }
        }

        return next.handle(req);
      })
    );
  }
}
